import script from "./PolicyFilesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyFilesModal.vue?vue&type=script&setup=true&lang=js"

import "./PolicyFilesModal.vue?vue&type=style&index=0&id=aec6cb6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aec6cb6a"]])

export default __exports__